import { useApi } from '@/hooks/useApi'

import { useCurrentConversationStore } from './useCurrentConversationStore'

/**
 * For creating a new conversation with a message.
 *
 * @param {string} title  The title of the conversation
 * @param {string} message  The message to send to the conversation
 *
 * @returns {Object}  The store
 */
export function useConversationManager() {
  const api = useApi()
  const setMessages = useCurrentConversationStore(state => state.setMessages)
  const setCurrentId = useCurrentConversationStore(state => state.setCurrentId)
  const setLoading = useCurrentConversationStore(state => state.setLoading)
  const isLoading = useCurrentConversationStore(state => state.loading)

  const createConversationWithMessage = async ({ title, message }) => {
    setLoading(true)
    if (isLoading) return
    const res = await api.createConversationWithMessage({ title, message })
    if (res.ok) {
      const { conversation, message: msg } = res.body
      setCurrentId(conversation.id)
      setMessages([msg])
      return { conversation, message: msg }
    }
    // handle error
    setLoading(false)
    return null
  }

  return { createConversationWithMessage }
}
